import { useTranslations } from "next-intl";
import st from "./index.module.scss";
export default function HeaderBackSearch({ deleteValue }: { deleteValue: () => void }) {
  const t = useTranslations("SearchModal");

  return (
    <div className={`${st.search_content__button_back}`}>
      <div
        className={`${st.search_content__button_back_icon_wrap}`}
        onClick={deleteValue}
        data-test="search_button_back"
      >
        <svg
          viewBox="0 0 17 12"
          fill="currentColor"
          width="18"
          height="100%"
          className={`icon ${st.search_content__button_back_icon}`}
        >
          <use xlinkHref="/images/icons/icons.ef5f637c.svg#arrow-2-left"></use>
        </svg>
      </div>
      <div className={`${st.search_content__button_back_text_wr}`}>
        <div className={`${st.search_content__button_back_text}`}>{t("header_back")}</div>
      </div>
    </div>
  );
}
